// extracted by mini-css-extract-plugin
export default {"add-role-to-user-form":"AddUserRoleToAccountForm_add-role-to-user-form__R80jQ"};